import { css } from '@firebolt-dev/css'
import { useEffect, useRef, useState } from 'react'

import { items } from '../../shared/Items'
import { cls } from '../utils'
import { ItemTooltip, TOOLTIP_DELAY } from './ItemTooltip'

export function InterfaceCell({ slot, x, y, onPointerDown, isDragging, isHighlighted, pointerCaptured }) {
  const item = slot ? items[slot.id] : null
  const cellRef = useRef(null)
  const [cellRect, setCellRect] = useState(null)
  const showTimeoutRef = useRef(null)
  const genRef = useRef(0)

  const showTooltip = !!cellRect && !isDragging && !!item

  const cancelTooltip = () => {
    genRef.current++
    clearTimeout(showTimeoutRef.current)
    setCellRect(null)
  }

  const handlePointerEnter = e => {
    const gen = ++genRef.current
    const delay = e.pointerType === 'touch' ? TOOLTIP_DELAY : 0
    showTimeoutRef.current = setTimeout(() => {
      if (gen === genRef.current && cellRef.current) setCellRect(cellRef.current.getBoundingClientRect())
    }, delay)
  }

  const handlePointerLeave = () => {
    if (!pointerCaptured) cancelTooltip()
  }

  // Clear tooltip when drag starts or pointer is released
  useEffect(() => {
    if (isDragging || !pointerCaptured) cancelTooltip()
  }, [isDragging, pointerCaptured])

  return (
    <div
      ref={cellRef}
      className={cls('interface-cell', {
        highlighted: isHighlighted,
        dragging: isDragging,
        tip: showTooltip,
      })}
      onPointerDown={onPointerDown}
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
      css={css`
        top: ${y}px;
        left: ${x}px;
        position: absolute;
        width: 20px;
        height: 20px;
        pointer-events: auto;
        padding: 2px;
        &.tip {
          z-index: 1;
        }
        &.highlighted {
          background: url('/assets/interface-highlight.png');
          background-size: contain;
          image-rendering: pixelated;
        }
        &.dragging {
          .interface-cell-item {
            opacity: 0.0001;
          }
        }
      `}
    >
      {item && (
        <div className='interface-cell-item pointer'>
          <img
            src={item.icon}
            css={css`
              display: block;
              width: 16px;
              height: 16px;
              image-rendering: pixelated;
              pointer-events: none;
            `}
          />
          {slot.qty > 1 && (
            <span
              css={css`
                position: absolute;
                bottom: 1px;
                right: 3px;
                font-size: 5px;
                /* font-weight: 600; */
                color: white;
                -webkit-text-stroke: 1.5px black;
                paint-order: stroke fill;
                pointer-events: none;
              `}
            >
              {slot.qty}
            </span>
          )}
        </div>
      )}
      {showTooltip && <ItemTooltip item={item} cellRect={cellRect} />}
    </div>
  )
}
